import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Stack } from '@mui/material';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import ShowComponents from '../Common/ShowComponent';
import { CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents';

class DocObstericDataLeft extends Component {
    constructor(props) {
        super(props)
        this.state = {
            obstericData: [],
            PatientData: this.props?.PatientData,
        }
    }

    componentDidUpdate(prevprops) {
        if ((prevprops.GetAPiCall !== this.props.GetAPiCall) && this.props.GetAPiCall) { this.GetObstericData() }
        if ((prevprops.SelectedComponent !== this.props.SelectedComponent) && this.props.SelectedComponent) {
            this.props.EditObstericData(this.state.obstericData?.length > 0 ? this.state.obstericData[0] : {})
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    GetObstericData() {
        try {
            RestAPIService.GetWithoutReplica(Serviceurls.DOC_OBSTETRIC_DATA_GET + `?appointment_id=${this.state.PatientData?.appointment_id}&patient_id=${this.state.PatientData?.patient_id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        const Data = response.data.data ? response.data.data : {};
                        this.setState({
                            obstericData: Object.keys(Data)?.length > 0 ? [{ sno: 1, ...Data }] : [],
                        }, () => { this.props.EditObstericData(Object.keys(Data)?.length > 0 ? Data : {picme: ""}) })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    PostObstericData = () => {
        try {
            const data = {
                "patient_id": this.props.PatientData.patient_id,
                "appointment_id": this.props?.PatientData?.appointment_id,
                "last_menstrual_period": null,
                "expected_date_of_delivery": null,
                "gravida": null,
                "para": null,
                "live_births": null,
                "abortions": null,
                "picme": "",
            }
            RestAPIService.create(data, Serviceurls.DOC_OBSTETRIC_DATA_GET)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.successMessage(response.data.message)
                        this.GetObstericData()
                    } else {
                        this.errorMessage(response.data.message)
                    }
                }).catch(error => {
                    this.errorMessage(error.response.data.message || error.message)
                })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    checkValue = (value) => {
        return (value !== undefined && value !== null)
    }

    render() {
        try {
            const { t } = this.props
            const columns = [
                {
                    field: "picme", flex: 0.14, headerName: t("PICME"),
                    renderCell: ({ row }) => (<Box component={'div'}>{this.checkValue(row?.picme) ? row?.picme : "-"}</Box>)
                },
                {
                    field: "gravida", flex: 0.14, headerName: t("Gravida"),
                    renderCell: ({ row }) => (<Box component={'div'}>{this.checkValue(row?.gravida) ? row?.gravida : "-"}</Box>)
                },
                {
                    field: "para", flex: 0.14, headerName: t("Para"),
                    renderCell: ({ row }) => (<Box component={'div'}>{this.checkValue(row?.para) ? row?.para : "-"}</Box>)
                },
                {
                    field: "live_births", flex: 0.14, headerName: t("Live Birth"),
                    renderCell: ({ row }) => (<Box component={'div'}>{this.checkValue(row?.live_births) ? row?.live_births : "-"}</Box>)
                },
                {
                    field: "abortions", flex: 0.14, headerName: t("Abortion"),
                    renderCell: ({ row }) => (<Box component={'div'}>{this.checkValue(row?.abortions) ? row?.abortions : "-"}</Box>)
                },
                {
                    field: "actions", flex: 0.14, headerName: t("Action"),
                    renderCell: ({ row }) => (<CommonDeleteButton size={"1.5vw"} disable={this.props?.isLocked} onClick={this.PostObstericData.bind(this)} />)
                },
                // {
                //     field: "last_menstrual_period", flex: 0.14, headerName: t("Last Menstrual Period"),
                //     renderCell: ({ row }) => (<Box component={'div'}>{row?.last_menstrual_period ? row?.last_menstrual_period : "-"}</Box>)
                // },
                // {
                //     field: "expected_date_of_delivery", flex: 0.14, headerName: t("Expected date of delivery"),
                //     renderCell: ({ row }) => (<Box component={'div'}>{row?.expected_date_of_delivery ? row?.expected_date_of_delivery : "-"}</Box>)
                // },
            ]
            return (
                <ShowComponents onIntersection={this.GetObstericData.bind(this)}>
                    <Box height={'20vh'} overflow={'auto'}>
                        <DataGrid
                            density='compact'
                            rows={this.state.obstericData}
                            columns={columns}
                            getRowId={(row) => row['sno']}
                            headerHeight={40}
                            hideFooter={true}
                            components={{
                                NoRowsOverlay: () => (
                                    <Stack className='eMed_DocNotes_no_records_text' height={'15vh'}>
                                        {t("NoRecordsFound")}
                                    </Stack>
                                )
                            }}
                            disableSelectionOnClick
                        />
                    </Box>
                    {this.state.isErrorMsg &&
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />}
                    {this.state.successMsg &&
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />}
                </ShowComponents>
            )
        }
        catch (e) {

        }
    }
}
export default withTranslation()(DocObstericDataLeft)